const notificationMessageList = {
  updateCache: 'UPDATE_CACHE',
  clearCache: 'CLEAR_CACHE',
  activeDevice: 'ACTIVATE',
  deactiveDevice: 'DEACTIVATE',
  restart: 'RESTART',
  turnOff: 'TURN_OFF',
  volumeMuteOn: 'MUTE_ON',
  volumeMuteOff: 'MUTE_OFF',
  setVolumeLevel: 'SET_VOLUME_LEVEL',
  unsetVolumeLevel: 'UNSET_VOLUME_LEVEL',
  volumeUp: 'VOLUME_UP',
  volumeDown: 'VOLUME_DOWN',
  takeScreenShots: 'TAKE_SCREENSHOTS',
  stopScreenShots: 'STOP_SCREENSHOTS',
  changeServer: 'CHANGE_SERVER',
  deviceStatus: 'DEVICE_STATUS',
  medicalEvent: 'MEDICAL_EVENT',
  locationChange: 'LOCATION_CHANGE',
  deactivatePermanent: 'DEACTIVATE_PERMANENT',
  ping: 'PING',
  pong: 'PONG',
};

export default notificationMessageList;
